
// src/hooks/use-toast.ts
import { toast as sonnerToast } from "sonner";

// Interface for our toast params that matches the UI component props
interface ToastParameters {
  title?: string;
  description?: string;
  variant?: "default" | "destructive" | "success";
  duration?: number;
  action?: React.ReactNode;
}

// Create our custom toast function that uses Sonner directly
export function toast({
  title = '',
  description,
  variant = "default",
  duration = 5000,
  action,
}: ToastParameters) {
  
  // Use Sonner toast with appropriate styling based on variant
  if (variant === "destructive") {
    return sonnerToast.error(title, {
      description,
      duration,
      action,
    });
  } else if (variant === "success") {
    return sonnerToast.success(title, {
      description,
      duration,
      action,
    });
  } else {
    return sonnerToast(title, {
      description,
      duration,
      action,
    });
  }
}

// Export the hook for compatibility with the component UI
export const useToast = () => {
  const toast = ({
    title = '',
    description,
    variant = "default",
    duration = 5000,
    action,
  }: ToastParameters) => {
    if (variant === "destructive") {
      return sonnerToast.error(title, {
        description,
        duration,
        action,
      });
    } else if (variant === "success") {
      return sonnerToast.success(title, {
        description,
        duration,
        action,
      });
    } else {
      return sonnerToast(title, {
        description,
        duration,
        action,
      });
    }
  };

  return {
    toast,
  };
};
